module.exports = __webpack_public_path__ + "img/SPV.bc2976f2.svg";